import { action } from 'typesafe-actions';
import { ICEXCheckResponse } from '@kattana-io/common';
import { IExtendedCEXBalanceItem } from '../reducers/cex_trading';

const entity = 'cex_trading';
const CHECK_CEX = `${entity}/CHECK`;
const CHECK_CEX_DONE = `${entity}/CHECK_DONE`;
const CHECK_CEX_FAIL = `${entity}/CHECK_FAIL`;
const REVOKE_CEX_KEYS = `${entity}/REVOKE_KEY`;
const UPDATE_CEX_BALANCE_ITEM = `${entity}/UPDATE_CEX_BALANCE_ITEM`;
const SET_CURRENT_EXCHANGE = `${entity}/SET_CURRENT_EXCHANGE`;

const actionCheckCEX = () => action(CHECK_CEX);
const actionCheckCEXDone = (data: ICEXCheckResponse) =>
  action(CHECK_CEX_DONE, data);
const actionCheckCEXFail = () => action(CHECK_CEX_FAIL);
const actionRevokeKeyCEXRequest = (exchange: string) =>
  action(REVOKE_CEX_KEYS, exchange);
const actionUpdateCexBalance = (data: IExtendedCEXBalanceItem) =>
  action(UPDATE_CEX_BALANCE_ITEM, data);
const actionSetCurrentExchange = (exchange: string) =>
  action(SET_CURRENT_EXCHANGE, exchange);

export {
  CHECK_CEX,
  CHECK_CEX_DONE,
  CHECK_CEX_FAIL,
  REVOKE_CEX_KEYS,
  UPDATE_CEX_BALANCE_ITEM,
  SET_CURRENT_EXCHANGE,
  actionCheckCEX,
  actionCheckCEXDone,
  actionCheckCEXFail,
  actionRevokeKeyCEXRequest,
  actionUpdateCexBalance,
  actionSetCurrentExchange,
};
